<template>
    <div id="app">
        <Header />
        <router-view />
    </div>
</template>

<script>
import Header from "./components/header/Header.vue";

export default {
    components: {
        Header
    }
};
</script>

<style lang="scss" module>
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: #f5f5f5;
}

::-webkit-scrollbar-track {
    background-color: #fff;
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgb(0 0 0 / 30%);
}

::-webkit-scrollbar-thumb {
    background-color: #aaa;
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgb(0 0 0 / 30%);
}
</style>
